import { Injectable } from '@angular/core';
import { ENTERPRISES_URL, VEHICLES_SUFFIX, BASE_URL, VEHICLES, ELECTRIC_VEHICLES } from '../../shared/constants/urls';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CustomStorageService } from '../custom-storage/custom-storage.service';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    authorization: 'bearer ' + this.storageService.getToken(),
  });

  constructor(private client: HttpClient,
    private readonly storageService: CustomStorageService) { }

  getVehicles(enterpriseId: string) {
    const query = '?enterprise=' + enterpriseId;
    return this.client.get(ELECTRIC_VEHICLES , { headers: this.headers });
  }

  deleteVehicle(id: string) {
    const enterpriseId = this.storageService.getEnterprise()._id;
    return this.client.delete(VEHICLES + id, { headers: this.headers });
  }

  getVehicleById(id) {
    const enterpriseId = this.storageService.getEnterprise()._id;
    return this.client.get(ELECTRIC_VEHICLES + id, { headers: this.headers });
  }

  createVehicle(body: any) {
    const enterpriseId = this.storageService.getEnterprise().id;
    body.owner = enterpriseId;
    body.enterprise = enterpriseId;
    return this.client.post(VEHICLES_SUFFIX, body, { headers: this.headers });
  }

  updateVehicle(body: any, idVehicle) {
    const enterpriseId = this.storageService.getEnterprise().id;
    body.enterprise = enterpriseId;
    return this.client.put(ELECTRIC_VEHICLES + idVehicle, body, { headers: this.headers });
  }
}
